import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { config } from '_helpers';
import CreatableAsyncSelect from '_components/utils/CreatableAsyncSelect/CreatableAsyncSelect';

// Ensure ReactModal app element is set
if (typeof document !== 'undefined') {
  ReactModal.setAppElement('#app');
}

const EmailFireCardsModal = ({
  emailFireCardsOpen,
  emailFireCardsCloseModal,
  handleSelectEmployees,
  selectedEmployees,
  onClickRemoveEmployeeFromMailList,
  emailFireCards,
}) => {
  return (
    <ReactModal isOpen={emailFireCardsOpen} onClose={emailFireCardsCloseModal}>
      <div id='statusPopup' className='popupModal'>
        <div className='modal-head ro-email-modal-head'>
          <h4 className='modal-title'>Email Fire Cards</h4>
        </div>
        <div className='modal-body ro-modal-body'>
          <CreatableAsyncSelect
            setSelectedEmployees={handleSelectEmployees}
            selectedEmployees={selectedEmployees}
          />
          {!!selectedEmployees.length && (
            <div className='mail-maifest-wrapper'>
              <div className='mail-manifest wrapper'>
                <div className='head'>
                  <div
                    className='name ro-email-modal-name'
                    style={{ fontWeight: 'bold' }}
                  >
                    Name
                  </div>
                  <div className='email' style={{ fontWeight: 'bold' }}>
                    Email
                  </div>
                </div>
                {selectedEmployees.map((item) => {
                  return (
                    <div
                      key={item.name + item.email}
                      className='employee employee_item selected-employee'
                    >
                      <div className='pic image-holder ro-profile-pic-wrapper'>
                        {(item.profilePic || item.name) && (
                          <img
                            src={
                              config.apiUrl +
                              '/' +
                              (item.profilePic ?? config.altImg)
                            }
                            onError={(e) =>
                              (e.target.src = `${config.apiUrl + '/' + config.altImg}`)
                            }
                            alt='prof-pic'
                          />
                        )}
                      </div>
                      <div className='name'>
                        <span className=''>{item.name}</span>
                      </div>
                      <div className='email'>{item.email}</div>
                      <div className='close-btn'>
                        <img
                          alt='close'
                          src={
                            require('../../assets/images/close_button.png')
                              .default
                          }
                          onClick={() =>
                            onClickRemoveEmployeeFromMailList(item)
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className='resource_order_form_delete_modal_action'>
            <button className='button grey' onClick={emailFireCardsCloseModal}>
              Cancel
            </button>
            <button
              name='save'
              className='button'
              onClick={emailFireCards}
              disabled={!selectedEmployees.length}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

EmailFireCardsModal.propTypes = {
  emailFireCardsOpen: PropTypes.bool.isRequired,
  emailFireCardsCloseModal: PropTypes.func.isRequired,
  handleSelectEmployees: PropTypes.func.isRequired,
  selectedEmployees: PropTypes.array.isRequired,
  onClickRemoveEmployeeFromMailList: PropTypes.func.isRequired,
  emailFireCards: PropTypes.func.isRequired,
};

export default EmailFireCardsModal;
